export const trapFocus = (e, domElement) => {
  const elementsToFocus = $(
    "a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type='text']:not([disabled]), input[type='radio']:not([disabled]), input[type='checkbox']:not([disabled]), select:not([disabled])"
  )
  const focusableEls = domElement.find(elementsToFocus).filter(":visible")
  const firstFocusableEl = focusableEls[0]
  const lastFocusableEl = focusableEls[focusableEls.length - 1]
  const KEYCODE_TAB = 9
  const isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB

  if (!isTabPressed) {
    return
  }

  if (e.shiftKey) {
    /* shift + tab */
    if (document.activeElement === firstFocusableEl) {
      lastFocusableEl.focus()
      e.preventDefault()
    }
  } else {
    /* tab */
    if (document.activeElement === lastFocusableEl) {
      firstFocusableEl.focus()
      e.preventDefault()
    }
  }
}
